import {TranslateService} from '@ngx-translate/core';
import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ProductTypeEnum} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-products',
    templateUrl: './select-products.component.html',
    styleUrls: ['./select-products.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectProductsComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SelectProductsComponent implements ControlValueAccessor {
    public options: { label: string; value: string }[] = [];
    @Input() inputId = '';
    @Input() fluid = false;
    @Input() placeholder = '';
    @Input() availableProducts?: ProductTypeEnum[];

    get visibleOptions(): { label: string; value: string }[] {
        return this.availableProducts == null ? this.options
            : this.options.filter(option => this.availableProducts.includes(option.value as ProductTypeEnum));
    }

    value: string[] = [];
    disabled = false;

    constructor(private readonly translate: TranslateService) {
        this.options = [
            {label: this.translate.instant('invoicing.common.flights'), value: ProductTypeEnum.FLIGHT},
            {label: this.translate.instant('invoicing.common.hotels'), value: ProductTypeEnum.HOTEL},
            {label: this.translate.instant('invoicing.common.parkings'), value: ProductTypeEnum.PARKING},
            {label: this.translate.instant('invoicing.common.cars'), value: ProductTypeEnum.CAR},
        ];
    }

    onChange: (value: any) => void = () => {
    };
    onTouched: () => void = () => {
    };

    writeValue(value: any): void {
        this.value = Array.isArray(value) ? value : [];
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    setValue(value: string[]) {
        if (this.disabled) {
            return;
        }
        const next = Array.isArray(value) ? [...value] : [];
        // shallow compare arrays (order-sensitive)
        const same = this.value.length === next.length && this.value.every((v, i) => v === next[i]);
        this.value = next;
        if (!same) {
            this.onChange(this.value);
        }
        this.onTouched();
    }
}
